'use strict';
import $ from 'jquery';

export default class search {
	constructor() {
		if($('.search').length > 0){
			$('.topic-btn').on('click', function(e){
				e.preventDefault;
				$('.topic-holder').toggleClass('open');
			});
			$('.search-btn').on('click', function(e){
				var $term = $('.search-input').val();
				window.location.href = '/search.html?' + $term
				e.preventDefault;
			})
			$('.search-input').on( "keydown", function(event) {
				if(event.which == 13){
					var $term = $('.search-input').val();
					window.location.href = '/search.html?' + $term
				}
			});
			
		}
		if($('.search-results').length > 0){
			var $term = window.location.search.substr(1);
			var $decode = decodeURI($term )
			if(!$term == ""){
				$('.search-term').text($decode);
			}
		}
		
		
	}
}